import EjariApiConfig from "./config";
import EjariApi from "./api";
import EjariHooks from "./Hooks";

export default EjariApi;
export { EjariApi, EjariApiConfig, EjariHooks };
